export default "__VITE_ASSET__9129d47f__"